var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AnablueSidebar',{attrs:{"data-v-step":"sidebar","items":_vm.sidebarItems,"minimize":_vm.$store.state.sidebarMinimize},on:{"update:minimize":(value) => _vm.$store.commit('set', ['sidebarMinimize', value])}})
}
var staticRenderFns = []

export { render, staticRenderFns }